import Hero from './components/Hero';
import ArticleHub from './components/ArticleHub';
import CategoryGrid from './components/CategoryGrid';
import CTASection from './components/CTASection';
import FeatureGrid from './components/FeatureGrid';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://cssspreadsheet.space';

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: 'CSS Spreadsheet',
            url: siteUrl,
            description: 'CSSBuy Spreadsheet is the largest curated resource hub for verified fashion finds, shoes, clothing, and accessories.',
            potentialAction: {
              '@type': 'SearchAction',
              target: `${siteUrl}/search?q={search_term_string}`,
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'CSS Spreadsheet',
            url: siteUrl,
            description: 'The most comprehensive CSSBuy Spreadsheet hub — curated fashion finds, verified links, and daily updated shopping resources.',
            sameAs: [
              'https://kaspreadsheet.com',
            ],
          }),
        }}
      />
      <main>
        <Hero />
        <ArticleHub />
        <CategoryGrid />
        <CTASection />
        <FeatureGrid />
        <Testimonials />
        <Footer />
      </main>
    </>
  );
}